import {$document} from "./globals";
import {echo} from "./common-new";

let bFormButton, validateTimeout;

if($.isFunction('rating')) {
    $('.StarFormRating').rating({});
}
const waitJs = $('[type="submit"].wait-js');
if (waitJs.length) {
    waitJs.removeClass('wait-js').removeAttr('disabled');
}
if (typeof CaAdminJs != "undefined") {
    CaAdminJs.RegisterFunctionAfterLoad(function () {
        $('[type="submit"].wait-js').removeClass('wait-js').removeAttr('disabled');
    });
}

$document.on('click', '.bForm *:submit', function () {
    bFormButton = this;
});
$document.on('input paste change keyup', '.bForm [livevalidation]', function (e) {
    clearTimeout(validateTimeout);
    validateTimeout = setTimeout(setValidateTimeout, 1000, $(this), $(this.form));
});
$document.on('submit', '.bForm', function (event) {
    const form = this;
    const $form = $(form);
    let is_ajax_form = false;
    const ajax_form_attr = $form.attr('data-isajax');

    if (typeof ajax_form_attr !== typeof undefined && ajax_form_attr !== false) {
        is_ajax_form = true;
    }

    if (!is_ajax_form) {
        if ($form.data('bForm')) {
            const data = $form.data('bForm');
            if (data.submit) {
                return;
            }
        }
    }
    event.preventDefault();
    if (is_ajax_form) {
        BFormCallCallback($form.attr('data-callbackajax'), 0, $form, null);
    }

    if ($form.find('[name="data[request-token]"]').length === 0) {
        const $tokenElement = $('<input name="data[request-token]" type="hidden" />');
        $tokenElement.val($(document.body).attr('data-request'));
        $form.append($tokenElement);
    }

    let ajaxData = null;
    ajaxData = new FormData($form[0]);
    ajaxData.append($(bFormButton).attr('name'), $(bFormButton).attr('value'));

    $.ajax({
        url: this.action,
        type: $form.attr('method'),
        dataType: 'json',
        data: ajaxData,

        contentType: false,
        cache: false,
        processData: false,

        error: function (errorMessage) {
            const error = 'Chyba bFormu: Seznam chyb pro formular musi byt v JSON formatu. \nMozna se vam formular zpracovava az behem vypisu a tim padem to nejde rozparsovat. \nMrknete do konzole na obsah AJAX requestu.';
            if (window.DEBUG_THIS_PROJECT) {
                alert(error);
            }
        },

        success: function (response) {
            let firstError = null;
            $form.find('.invalid-feedback').remove();
            $('.invalid-feedback').each(function () {
                const _ = $(this);
                _.remove();
                _.parent().closest('input').addClass('is-valid')
            });
            $('.is-invalid').each(function () {
                const _ = $(this);
                _.removeClass('is-invalid');
                _.addClass('is-valid');
            });

            //musel jsem si ajaxove responsy potunit podle toho, zda je response chyba bformu a nebo success informace...
            let errors = false;
            if (typeof response.bformerrors !== undefined) {
                errors = response.bformerrors
            }
            if (errors) {

                if (is_ajax_form) {
                    BFormCallCallback($form.attr('data-callbackajax'), 2, $form, errors);
                }


                for (const name in errors) {
                    let errorMessage = null;
                    if (name == '') { //globalni chyba
                        errorMessage = $form.find('.bFormError');
                        if (errorMessage.length == 0) {
                            errorMessage = $('<div class="bFormError c-alert c-alert--blue w-100 u-mb-2"></div>').prependTo(form);
                        }
                        errorMessage.html(errors['']);
                        firstError = errorMessage;
                    } else {
                        const selector = '[name="' + errors[name].selector + '"]:first'; // first -> u radia to vypisovalo vicekrat
                        const input = $form.find(selector);
                        if (input.length === 0) echo('Nic jsem nenasel pro selekor ' + selector);
                        const parent = input.parent();
                        input.addClass('is-invalid');
                        errorMessage = $(`<div class="invalid-feedback"> ${errors[name].error}</div>`);
                        // errorMessage = $('<div class="alert alert-danger fade in show padding5 marginBottom5"><a href="#" class="close" data-dismiss="alert">×</a><strong>' + translate('CHYBA') + '!</strong> ' + errors[name].error + '</div>');
                        if (input.is(':checkbox')) {
                            input.siblings('label').after(errorMessage);
                        } else {
                            input.after(errorMessage);
                        }
                        if (firstError == null) firstError = errorMessage;
                    }
                }
            }

            if (firstError !== null) {
                const modal = firstError.closest('.c-modal');
                if (modal.length) {
                    modal.find('.c-modal__body').animate({
                        scrollTop: firstError.parent().position().top - 20
                    }, 1000);
                } else {
                    $('html, body').animate({
                        scrollTop: firstError.parent().offset().top - (window.innerHeight / 2)
                    }, 1000);
                }
            } else {
                if (is_ajax_form) {
                    BFormCallCallback($form.attr('data-callbackajax'), 1, $form, response);
                    return;
                }
                $form.data('bForm', {submit: true});
                $(bFormButton).trigger('click');
            }
        }
    });
});


const setValidateTimeout = function (element, form) {
    solveAjaxValidation(element, form);
};

const solveAjaxValidation = ($this, formAttr) => {

    const attributeName = $this.attr('livevalidation');
    let attributesToSend = $this.attr('livevalidationinputs');
    attributesToSend = attributesToSend == null ? null : attributesToSend.split(",");

    let values = {};

    if (attributesToSend == null) {
        values[encodeURI(attributeName)] = $this.val();
    } else {
        attributesToSend.forEach(function (item) {
            values[encodeURI(item)] = $(`input[livevalidation='${item}']`).val();
        });
    }

    const formName = formAttr.find("input[name=bForm]").val();

    $.ajax({
        type: "POST",
        url: ABSOLUTE_URL + 'classes/b-form-ajax.php',
        data: {func: 'liveValidation', validateFor: encodeURI(attributeName), inputs: values, form: formName},
        dataType: 'json',
        success: function (data) {
            if (data.error) {
                const keys = Object.keys(data.errors);
                for (let i = 0; i < keys.length; i++) {
                    const $select = $(`.bForm [livevalidation='${keys[i]}']`);
                    $select.parent().find(".invalid-feedback").remove();

                    $select.removeClass('is-invalid');
                    $select.removeClass('is-valid');
                    $select.removeClass('ajax-invalid');

                    if (data.errors[keys[i]] !== "") {

                        if (data.error === true) {
                            $select.addClass('is-invalid ajax-invalid');
                            const errorMessage = $(`<div class="invalid-feedback"> ${data.errors[keys[i]]}</div>`);
                            $select.after(errorMessage);
                        }
                        //Vypne tlacitko submit pokus napjde alert-danger
                        //formAttr.find("input[type=submit]").prop('disabled', formAttr.find(".ajax-invalid").length > 0);
                    }
                }
            } else {
                for (let i = 0; i < data.errors.length; i++) {
                    const $select = $(`.bForm [livevalidation='${data.errors[i]}']`);
                    $select.parent().find("div.invalid-feedback").remove();
                    $select.addClass('is-valid');
                    $select.removeClass('ajax-invalid');
                    $select.removeClass('is-invalid');
                    //formAttr.find("input[type=submit]").prop('disabled', formAttr.find(".ajax-invalid").length > 0);
                }
            }

        }
    });
}


/**
 * Zavola callback
 * @param fn_callback string Jmeno fce
 * @param state int  0 => Zacatek, 1 => OK, konec, 2 => chyby
 * @param $form Form objekt
 * @param response_errors json Response/chyby z ajaxu
 */
export const BFormCallCallback = (fn_callback, state, $form, response_errors) => {
    if (typeof fn_callback !== typeof undefined && fn_callback !== false) {
        const callback_fc = window[fn_callback];
        if (typeof callback_fc === 'function') {
            callback_fc.call(this, state, $form, response_errors);
        }
    }
}